/* sb-dc-finrail.js — finishing options in the right rail, next to Design.
   2026-09-05.

   The "Size and options" dialog is gone (see sb-dc-sizeonly.js): size and
   quantity already live in the left Size panel, so the only thing the dialog
   still carried was the finishing choice. This puts that choice where the
   customer is looking — the right rail, under the Design thumbnail — and keeps
   it visible instead of two clicks deep.

   The options are per product: __dcFinishingAllowed() returns the ids this
   product can actually be made with, so a step & repeat shows pole pockets and
   a sticker shows nothing at all. The pop-up backdrop is excluded outright —
   its fabric is sewn into a sleeve, which is the same rule sb-dc-popupbackdrop
   .js applies inside the dialog.

   Setting one goes through api.setSpec({finishing}), the same call the dialog
   made, so the price and the cart line behave exactly as before.

   Labels are held here rather than scraped from the left panel, which only
   exists while that panel is open. An id we do not know about still renders,
   spelled out from the id itself, so a new finishing option appears rather
   than silently going missing.

   Diagnostics: window.__dcFinRail. */
(function () {
  'use strict';

  var BOX_ID = 'sbdc-finrail';
  var NO_FINISHING = /pop-up-display-backdrop-banner-only$/;

  var LABELS = {
    'hem-grommets': ['Hem + Grommets', 'Standard \u00b7 hem all round, grommets every 30\u2033'],
    'hem-only': ['Hem only', '1\u2033 hem sewn on all sides, no holes'],
    'grommets-only': ['Grommets only', 'Cut edge with grommets, no hem'],
    'none': ['No hem, no grommets', 'Cut only \u2014 no hanging hardware'],
    'pockets-both': ['Pole pockets, top and bottom', '4.5\u2033 folded into a pocket each end'],
    'pockets-top': ['Pole pocket, top only', 'Top 4.5\u2033 folded into a pocket']
  };

  var state = { shown: false, ids: [], current: null };
  window.__dcFinRail = state;

  function api() { return window.__dcApi || null; }

  function handle() {
    try {
      var p = window.__dcAppliedProduct && window.__dcAppliedProduct();
      return (p && p.handle) || '';
    } catch (e) { return ''; }
  }

  function allowed() {
    try {
      var ids = window.__dcFinishingAllowed && window.__dcFinishingAllowed();
      return Array.isArray(ids) ? ids : [];
    } catch (e) { return []; }
  }

  function pretty(id) {
    return String(id).replace(/[-_]+/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
  }

  function css() {
    if (document.getElementById('sbdc-finrail-css')) return;
    var st = document.createElement('style');
    st.id = 'sbdc-finrail-css';
    /* Sized and coloured off the Design card next to it (white, 14px radius,
       1.25px #c3d0d6) so the rail reads as one column. */
    st.textContent =
      '#' + BOX_ID + '{margin-top:14px;background:#fff;border:1.25px solid #c3d0d6;border-radius:14px;' +
      'padding:12px 12px 10px;font-family:Archivo,system-ui,sans-serif}' +
      '#' + BOX_ID + ' .sbdc-fr-title{display:block;font-size:11px;letter-spacing:.08em;text-transform:uppercase;' +
      'color:#7c8b95;font-weight:700;margin:0 0 8px}' +
      '#' + BOX_ID + ' button{display:block;width:100%;text-align:left;border:1px solid #dbe3e8;background:#fff;' +
      'border-radius:9px;padding:8px 10px;margin:0 0 6px;cursor:pointer;font:inherit;color:#12232b}' +
      '#' + BOX_ID + ' button:hover{border-color:#00697f}' +
      '#' + BOX_ID + ' button.is-on{border-color:#00697f;background:#e9f5f8}' +
      '#' + BOX_ID + ' b{display:block;font-size:12.5px;font-weight:700;line-height:1.3}' +
      '#' + BOX_ID + ' small{display:block;font-size:11px;color:#7c8b95;line-height:1.35;margin-top:2px}' +
      '#' + BOX_ID + ' .sbdc-fr-free{float:right;font-size:10.5px;color:#00697f;font-weight:700}';
    document.head.appendChild(st);
  }

  function render() {
    var rail = document.querySelector('aside.sides-panel');
    var a = api();
    if (!rail || !a) return;

    var ids = allowed();
    var off = NO_FINISHING.test(handle()) || ids.length < 2;
    var box = document.getElementById(BOX_ID);

    if (off) {
      state.shown = false;
      if (box) box.remove();
      return;
    }

    var current = a.spec && a.spec.finishing;
    /* 이 상품에 없는 마감이 남아 있으면 첫 항목으로 (보이는 것과 주문되는 것이 같게) */
    if (ids.indexOf(current) < 0) { a.setSpec({ finishing: ids[0] }, false); current = ids[0]; }
    var key = ids.join(',') + '|' + handle();
    var same = box && box.dataset.ids === key;
    if (!box) {
      css();
      box = document.createElement('div');
      box.id = BOX_ID;
      rail.appendChild(box);
    }

    if (!same) {
      box.dataset.ids = key;
      state.current = null;   // new buttons carry no is-on yet - mark the pick again below
      box.innerHTML = '<span class="sbdc-fr-title">Finishing<span class="sbdc-fr-free">Free</span></span>';
      ids.forEach(function (id) {
        var pair = LABELS[id] || [pretty(id), ''];
        var b = document.createElement('button');
        b.type = 'button';
        b.dataset.fin = id;
        b.innerHTML = '<b></b><small></small>';
        b.querySelector('b').textContent = pair[0];
        b.querySelector('small').textContent = pair[1];
        b.addEventListener('click', function () {
          try { api().setSpec({ finishing: id }); } catch (e) {}
        });
        box.appendChild(b);
      });
    }

    /* Reflect whatever the app thinks is selected, including a change made
       from somewhere else. */
    if (state.current !== current) {
      state.current = current;
      var bs = box.querySelectorAll('button');
      for (var i = 0; i < bs.length; i++) {
        bs[i].classList.toggle('is-on', bs[i].dataset.fin === current);
      }
    }
    state.shown = true;
    state.ids = ids;
  }

  var t = setInterval(function () { try { render(); } catch (e) {} }, 400);
  window.addEventListener('pagehide', function () { clearInterval(t); });
})();
